import { inject, Injectable, signal } from "@angular/core";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { OidcAuthenticationConfig } from "../app/auth/types";

@Injectable({
  providedIn: "root",
})
export class TokenService {
  public oidc = inject(OidcSecurityService);
  public httpToken = signal("");

  public async setHttpToken() {
    const elevatedToken = await this.oidc.getAccessToken(OidcAuthenticationConfig.SelfService).toPromise();

    if (elevatedToken !== "") {
      this.httpToken.set(elevatedToken);
    } else {
      const defaultToken = await this.oidc.getAccessToken(OidcAuthenticationConfig.Default).toPromise();
      this.httpToken.set(defaultToken);
    }
  }
}
